import styled from '@emotion/styled';

import { IDropdownItem, ITheme, StyledSelectMain } from '../../../ui';
import {
	IMultiSelectProps,
	MultiSelect,
} from '../../../ui/components/Select/MultiSelect/MultiSelect';
import { StyledMultiSelectDropdownList } from '../../../ui/components/MultiselectDropdownList/MultiSelectDropdownList';

interface IMultiSelectInputProps extends IMultiSelectProps {
	items: IDropdownItem[];
	onChange: (selectedItems: IDropdownItem[]) => void;
	initialSelectedItems?: IDropdownItem[];
	placeholder?: string;
	onClick?: () => void;
}

export const MultiSelectInput = ({
	items,
	onChange,
	initialSelectedItems,
	placeholder,
	onClick,
	...rest
}: IMultiSelectInputProps) => (
	<StyledMultiSelect
		items={items}
		initialSelectedItems={initialSelectedItems}
		placeholder={placeholder}
		placeholderAsLabel
		onClick={onClick}
		onChange={onChange}
		{...rest}
	/>
);

const StyledMultiSelect = styled(MultiSelect)<{}, ITheme>`
	font-weight: 400;

	${StyledMultiSelectDropdownList} {
		border-radius: 8px;
		margin-top: 0;
	}

	${StyledSelectMain} {
		width: max-content;
	}
`;
